export const FREESHIPPING_CODE_ACTIVE_AFTER = 15;
